import React from 'react';
import SVG from 'react-inlinesvg';
import classes from '../InCallParticipant.module.scss';
import { hooks } from '@lifesize/clients.sdk';
import { useDispatch } from 'react-redux';
import Modals from 'constants/Modals';
import { openInCallModal } from 'actions/InCallModal';
import presentIcon from '@lifesize/ux-assets/vectors/svgIcons/share-screen.svg';

interface props {
  participant: any;
}

export const ParticipantPresentationButton = ({ participant }: props) => {
  const userIsModerator = hooks.useIsCurrentUserModerator();
  const { isPresenting } = participant;
  const dispatch = useDispatch();

  const handleStopPresenterClicked = (participant) => {
    dispatch(openInCallModal(Modals.stopPresenter, { participant }));
  };

  if (!isPresenting) return null;
  if (userIsModerator) {
    return (
      <button className={classes.button} onClick={() => handleStopPresenterClicked(participant)}>
        <SVG
          src={presentIcon}
          className={`${classes.buttonIcon} ${classes.presenterIcon}`}
          data-testid="menuIconPresent"
        />
      </button>
    );
  }
  return (
    <div className={`${classes.button} ${classes.noButton}`}>
      <SVG
        src={presentIcon}
        className={`${classes.buttonIcon} ${classes.presenterIcon}`}
        data-testid="menuIconPresent"
      />
    </div>
  );
};

export default ParticipantPresentationButton;
